import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "scene-container" }
const _hoisted_3 = { class: "configurator-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")!
  const _component_SceneViewer = _resolveComponent("SceneViewer")!
  const _component_KnobConfigurator = _resolveComponent("KnobConfigurator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoadingIndicator, {
      visible: _ctx.isLoading,
      "loading-text": ''
    }, null, 8, ["visible"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SceneViewer, {
        ref: "sceneViewer",
        onLoadingChanged: _ctx.handleLoadingChange
      }, null, 8, ["onLoadingChanged"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_KnobConfigurator, {
        onKnobTypeChanged: _ctx.handleKnobTypeChange,
        onMaterialChanged: _ctx.handleMaterialChange,
        onEnclosureMaterialChanged: _ctx.handleEnclosureMaterialChange,
        onLedChanged: _ctx.handleLEDChange,
        "current-configuration": _ctx.currentConfiguration,
        "is-loading": _ctx.isLoading
      }, null, 8, ["onKnobTypeChanged", "onMaterialChanged", "onEnclosureMaterialChanged", "onLedChanged", "current-configuration", "is-loading"])
    ])
  ]))
}